import type { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { refineUniqueIds } from '~/services/api/contracts/refineUniqueIds'
import { SyncMenuItemPlacementsRequestSchema } from '~/services/api/generated'

const schema = SyncMenuItemPlacementsRequestSchema.strict()

export const MenuItemSyncPlacements = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  schema.superRefine((value, issues) => {
    refineUniqueIds(
      value,
      issues,
      'placements',
      'menu_category_id',
      'placements_menu_category_id_duplicate'
    )
  })
